import { GridRowId } from '@mui/x-data-grid-pro';

// I tuoi tipi originali
export type RawCell = { name: string; value: string | number };
export type RawRow = RawCell[];
export interface ColumnDef { name: string; label: string; type: string; }

// Tipo piatto per MUI DataGrid
export type FlatRow = Record<string, any> & { id: GridRowId; isNew?: boolean };

/**
 * Converte il tuo array di array nel formato piatto.
 * Da richiamare quando ricevi i dati dal server prima di settare lo stato "rows".
 */
export const flattenRows = (rawRows: RawRow[]): FlatRow[] => {
    return rawRows.map((rawRow, index) => {
        // Generiamo un ID fittizio basato sull'indice se non ne hai uno reale.
        // L'ideale sarebbe che il tuo backend restituisse un campo "id" nelle celle!
        const flat: FlatRow = { id: `row-${index}` };
        rawRow.forEach((cell) => {
            flat[cell.name] = cell.value;
        });
        return flat;
    });
};

/**
 * Riporta una singola riga piatta al tuo formato ad array di celle.
 * Da richiamare nelle callback onAddRow e onEditRow prima di inviare i dati al server.
 */
export const unflattenRow = (flatRow: FlatRow, columns: ColumnDef[]): RawRow => {
    return columns.map((col) => ({
        name: col.name,
        value: flatRow[col.name] !== undefined ? flatRow[col.name] : '',
    }));
};